import React, { useRef, useState } from 'react';

import SelectionSearchView from 'views/widgets/SelectionSearchView.jsx'; 
import WindowDialog from 'views/widgets/WindowDialog.jsx';
import InputView from 'views/widgets/InputView.jsx';
import BooleanCell from 'views/widgets/BooleanCell.jsx';

import { formatDateToLocalDateTime } from  '../../util/DateUtil.js'; 
import useSession from '../../hooks/useSession'; 

export default function SelectRevisionDialog(props) {
	
	const { url, id, name, pickFromOtherInstance, excludeLiveRevision, okCallback, cancelCallback } = props;
	const widthMatches = window.matchMedia("(min-width: 600px)").matches;
	const heightMatches = window.matchMedia("(min-height: 600px)").matches;	

	const formatDate = date => formatDateToLocalDateTime(null, date);
	const { session } = useSession();
	let possibleInstances = session.currentRole.workspace.instances.filter((instance) => !pickFromOtherInstance || instance.id != session.instance.id);
	possibleInstances.sort((a, b) => {
		let fa = a.name.toLowerCase(), fb = b.name.toLowerCase();
		if (fa < fb) return -1;
		if (fa > fb) return 1;
		return 0;
	});
	const [ currentInstance, setCurrentInstance ] = useState(pickFromOtherInstance ? possibleInstances[0] : session.instance); 
	const [ selectedState, setSelectedState ] = useState({}); 
	
	let columns = [
		{ field: "number", title: "Revision", sort: "revisionNumber", width: 75 },
		{ field: "commitMessage", title: "Commit Message", sort: "revisionCommitMessage", width: 225 },
		{ field: "last_updated_date", title: "Timestamp", sort: "revisionLastUpdatedDate", width: 150, transform: formatDate },
	];
	if (!excludeLiveRevision) 
		columns = columns.concat({ field: "live", title: "Active", sort: "revisionLive", width: 75, align: 'center', cell: ({dataItem}) => { return <BooleanCell flag={dataItem.live} /> } });
	
	const sort = [
		{ field: "revisionNumber", dir: "desc" }
	];
	
	const selectionView = useRef();
	
	const instanceChanged = (event) => {
		setCurrentInstance(event.value);
	};
	
	const getSelectionView = () => {
	
		return (
			<div className="constituo-dialog-grid-panel">
				<InputView key={"instance"} field={"name"} type={"combobox"} label={"Instance: "}
					disabled={false} hidden={false}
					readOnly={false}
					onChange={instanceChanged}
					data={possibleInstances} dataItemKey={'id'} textField={'name'}
					value={currentInstance} 
					style={{ margin: "0px", flex: "0 0 auto" }}
				/>
				<div className="constituo-dialog-grid-panel" style={{ paddingTop: "10px" }}>
					<SelectionSearchView
						ref={selectionView}
						className="constituo-selection-view"
						gridClass="constituo-selection-grid-container"
						label={""}
						elemId="revisionSelectionView"
						columns={columns}
						sort={sort} 
						type={"revisions"}
						url={url + "revisions/" + id}
						additionalUrlParams={"&instance=" + currentInstance.id + (excludeLiveRevision ? '&excludeLive=true' : "")}
						selectionMode={"single"}
						selectedState={selectedState}
						setSelectedState={setSelectedState}						
					/>		
				</div>
			</div>
		);
	};
	
	const okBtnClicked = () => {
		let selected = selectionView.current.getSelected();
		okCallback(id, selected[0], currentInstance.id);
	};
	
	const anythingSelected = () => {
		let keys = Object.keys(selectedState);
		keys.filter((key) => selectedState[key]);
		return keys.length > 0;
	};
	
	const getButtons = () => {
		let buttons = [];
		if (anythingSelected())
			buttons.push(
				<button
					key="ok-btn"
            		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              		onClick={okBtnClicked}
            	>
            		OK
            	</button>
            );
		buttons.push(
           	<button
           		key="cancel-btn"
           		className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
           		onClick={cancelCallback}
           	>
            		Cancel
           	</button>				
		);
		return buttons;
	};
	
	return (
		<WindowDialog
			contentLayout="grid"
			title={"Select Revision for " + name} 
			onClose={cancelCallback} 
			initialHeight={heightMatches ? 600 : 400}
			minHeight={300}
			initialWidth={widthMatches ? 600 : 400}
			minWidth={300}
			render={getSelectionView}
			buttons={getButtons()}
		/>
	);
}